import { API_URL } from "../config/connect";

const postUser = async (email, name, role) => {
  const endpoint = `${API_URL}/api/v1/admin/moderator`;
  const googleIdToken = localStorage.getItem("google_id_token");

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${googleIdToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, name, role }),
    });

    if (!response.ok) {
      let errorMessage = "Failed to add user";
      try {
        const errorBody = await response.json();
        if (errorBody?.error?.message) {
          errorMessage = errorBody.error.message;
        } else if (errorBody?.message) {
          errorMessage = errorBody.message;
        } else if (typeof errorBody?.detail === "string") {
          // FastAPI HTTPException
          errorMessage = errorBody.detail;
        } else if (Array.isArray(errorBody?.detail) && errorBody.detail[0]?.msg) {
          // FastAPI validation error
          errorMessage = errorBody.detail[0].msg;
        }
      } catch {
        // ignore JSON parse errors and keep default message
      }
      const error = new Error(errorMessage);
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export default postUser;